<template>
  <div :class="[$style.progressBar, variant ? $style[`progressBar-${variant}`] : '']">
    <div :class="$style.progressLabels" class="progressLabels">
      <p :class="$style.leftTitle" class="leftTitle">
        <BitTimer
          v-if="timerDate"
          :class="$style.leftTitleTimer"
          :start-time="Date.now()"
          :end-time="new Date(timerDate).getTime()"
          :is-background="false"
          :title-days="components.timer.daysTitle"
          :title-hours="components.timer.hoursTitle"
          :title-minutes="components.timer.minutesTitle"
          :title-seconds="components.timer.secondsTitle"
          @timeOut="$emit('timeOut')"
        />
        {{ leftTitle }}
      </p>
      <p v-if="!isCenterTitleHidden" :class="$style.centerTitle">
        {{ progress }}
      </p>
      <p
        :class="[$style.rightTitle, { [$style.rightTitleHidden]: isRightTitleHidden }]"
        class="rightTitle"
      >
        <span>{{ rightTitle }}</span>
        <BitTooltip
          v-if="tooltipText"
          :class="$style.rightTitleTooltip"
          :tooltip-text="tooltipText"
          :tooltip-width="tooltipWidth"
          is-show-on-hover
          tooltip-position="top-right"
        />
      </p>
    </div>
    <div :class="$style.progressBarLine" :style="{ '--progress': progress }">
      <span />
    </div>
  </div>
</template>

<script lang="ts" setup>
import { BitTooltip, BitTimer } from '@bit/ui-kit';
import { useStoreComponents } from '~/stores/strapi/components';
interface progressBarProps {
  leftTitle: string;
  rightTitle: string;
  progress: string;
  tooltipText?: string;
  tooltipWidth?: string;
  timerDate?: string;
  isRightTitleHidden?: boolean;
  isCenterTitleHidden?: boolean;
  variant?: 'profile';
}

defineProps<progressBarProps>();

defineEmits<{
  (e: 'timeOut'): void;
}>();

const components = useStoreComponents();
</script>

<style lang="scss" module src="./progressBar.scss"></style>
